import { Box, Button, Flex, Heading, Link, Stack, Text } from '@chakra-ui/react'
import { FaApple, FaGooglePlay } from 'react-icons/fa'

// TODO: replace with the actual store listing URLs
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.NeMiniA.ROPH'
const APP_STORE_URL = 'https://testflight.apple.com/join/zDUK2R5B'

const StoreButton = ({ href, icon, label }) => (
  <Link href={href} isExternal _hover={{ textDecoration: 'none' }}>
    <Button variant="outline" leftIcon={icon} w={{ base: 'full', sm: '149px' }}>
      {label}
    </Button>
  </Link>
)

const MobileDownload = () => (
  <Box
    bg="main-gray"
    borderLeft="5px solid var(--chakra-colors-maroon)"
    p={5}
    mb={5}
  >
    <Flex
      direction={{ base: 'column', md: 'row' }}
      justify="space-between"
      align={{ base: 'stretch', md: 'center' }}
      gap={4}
    >
      <Box>
        <Heading fontSize={[20, 24]} fontWeight={800}>
          RAN Online PH is now on Mobile!
        </Heading>
        <Text fontSize={14} opacity={0.8} mt={1}>
          Download here:
        </Text>
      </Box>

      <Stack direction={{ base: 'column', sm: 'row' }} spacing={2}>
        <StoreButton
          href={PLAY_STORE_URL}
          icon={<FaGooglePlay />}
          label="PLAY STORE"
        />
        <StoreButton
          href={APP_STORE_URL}
          icon={<FaApple size={16} />}
          label="APP STORE"
        />
      </Stack>
    </Flex>
  </Box>
)

export default MobileDownload
